import { Request } from "./request";

export interface FileDataParams {
  exCloseEndTime?: string;
  exCloseStartTime?: string;
  exOpenEndTime?: string;
  exOpenStartTime?: string;
  osIds?: string;
  pn?: number;
  ps?: number;
  regionCode?: string;
}

export function FileDataPage(params: FileDataParams): Request {
  return {
    url: "/api/data/center/example/list",
    method: "POST",
    body: params,
  };
}


